import { z } from "zod";

export const nameFilterSchema = z.object({
  name: z.string().catch("").default(""),
});
